export default __webpack_public_path__ + "static/media/chat_timeout.b2304059.svg";